import React, {useEffect, useState} from 'react'
import {Space} from 'antd'
import TablePageComponent from '@/components/adminPage'
import DetailDrawer from '@/pages/company/detail'
import Api from '@/api'

interface IQueryEnType {
  current: number
  size: number
  keyWord?: string
}

/**
 * 差旅页面
 * @returns
 */
const CompanyListPage = () => {
  const [TableLoading, setTableLoading] = useState<boolean>(false)
  const [TableData, setTableData] = useState<Array<any>>()
  const [ShowEdit, setShowEdit] = useState<boolean>(false)
  const [TotalCount, setTotalCount] = useState<number>()
  const [QueryEn, setQueryEn] = useState<IQueryEnType>({
    current: 1,
    size: 10
  })
  const [CorpId, setCorpId] = useState<string>("")


  const columns: any = [
    {
      title: '企业名称',
      key: 'corpName',
      dataIndex: 'corpName',
    },
    {
      title: '企业ID',
      dataIndex: 'corpId',
      key: 'corpId',
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime',
    },
    // {
    //   title: '状态',
    //   dataIndex: 'corpState',
    //   key: 'corpState',
    //   render: (text: number, record: any, index: number) => (
    //     <>
    //       {text == 0 ? '开启' : '停用'}
    //     </>
    //   ),
    // },
    {
      title: '操作',
      key: 'address',
      width: 150,
      render: (text: string, record: any, index: number) => (
        <>
          <Space size="middle">
            {/*<a type="text">
              {record.corpState == 1 ? '开启' : '停用'}
            </a>*/}
            <a type="text" onClick={() => {
              setCorpId(record.corpId)
              setShowEdit(true)
            }}>
              进入
            </a>
          </Space>
        </>
      ),
    },
  ]


  /**
   * 获取列表信息
   */
  const getList = async () => {
    setTableLoading(true)
    const _data: any = await Api.Company.CompanyList(QueryEn).finally(() => setTableLoading(false))
    if (_data) {
      setTotalCount(_data.pageResult.total)
      setTableData(_data.pageResult.records)
    }
  }

  useEffect(() => {
    getList()
  }, [QueryEn])

  return (
    <>
      {ShowEdit && <DetailDrawer corpId={CorpId} close={() => setShowEdit(false)}/>}
      <TablePageComponent
        columns={columns}
        loading={TableLoading}
        tableData={TableData}
        title={"系统集成"}
        pagination={{
          current: QueryEn.current,
          pageSize: QueryEn.size,
          total: TotalCount,
          showTotal: (total, range) => `${range[0]}-${range[1]}, 共 ${total} 条`,
          showSizeChanger: true,
          onChange: (page, pageSize) => {
            setQueryEn({
              current: page,
              size: pageSize
            })
          }
        }}
      />
    </>
  )
}

export default CompanyListPage
